import { defineStore } from 'pinia'
import { OrderTypes } from '../components/modules/app-steps/step-two/tabs/tabs-data'
import currency from 'currency.js'
import { IS_MAIN_STORAGE_KEY } from '@modules/app-steps/step-one/useSpecialPackage'
export const useOrderStore = defineStore('order', {
  state: () => {
    return {
      order: null,
      orderType: null,
      selectedOrderType: null,
    }
  },

  actions: {
    setOrder(order) {
      this.order = order
      const orderType = order.orderType
      const isWriting = !!order.writing

      this.setOrderType(orderType)

      if (orderType === OrderTypes.RedeemedCredit) {
        this.setSelectedOrderType(OrderTypes.Normal)
      }

      if (isWriting && orderType !== OrderTypes.CreditOnly) {
        this.setSelectedOrderType(OrderTypes.WritingService)
      }

      // if (
      //   orderType === OrderTypes.RedeemedCredit &&
      //   isWriting &&
      //   isRedeemedWritingCredit
      // ) {
      //   this.setSelectedOrderType(OrderTypes.RedeemedCreditWriting)
      // }
    },

    setOrderType(orderType) {
      this.orderType = orderType
    },

    setSelectedOrderType(orderType) {
      this.selectedOrderType = orderType
    },

    clearOrder() {
      this.order = null
      this.orderType = null
      this.selectedOrderType = null
    },
  },

  getters: {
    orderId: ({ order }) => order?.id,
    totalPrice: ({ order }) => currency(order?.total).format(),
    isWriting: ({ order }) => !!order?.writing,
    isSpecialPackage: () => {
      return localStorage.getItem(IS_MAIN_STORAGE_KEY) === 'no'
    },
    isCreditOnlySpecialPackage: () => {},
  },
})
